"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestSubTypeManager = void 0;
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../../common");
const ToggleSwitch_1 = require("../../../../../common/element/ToggleSwitch");
const server_1 = require("../../../../../server");
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const headTitleList = [
    { title: 'subTypeName', space: 4, sort: false, minWidth: 60 },
    { title: 'manage', space: 1, sort: false, minWidth: 72 },
    { title: 'subTypeEnabled', space: 1, sort: false, minWidth: 64 },
];
const tableReadDataKeys = [
    { title: 'title', space: 4, minWidth: 60 },
    { title: 'manage', space: 1, minWidth: 72 },
    { title: 'enabled', space: 1, minWidth: 64 },
];
const Styled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 0;
	padding: 4px 0;

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #101010;
		margin-bottom: 12px;
	}

	.add-section {
		padding-bottom: 20px;
	}

	.divider {
		height: 1px;
		background: #e8e8e8;
		margin-bottom: 20px;
	}

	.list-section {
	}

	.action-btns {
		display: flex;
		gap: 6px;
		justify-content: center;
		width: 100%;

		svg {
			cursor: pointer;
		}
	}

	.table-wrapper {
		padding: 0 !important;
	}

	.sub-type-table {
		display: flex;
		flex-direction: column;
		align-items: center;
		align-self: stretch;
		flex: 1;
	}

 	.table-header {
    	background: var(--color-silver, #f3f4f8);
    	border-style: solid;
    	border-color: var(--color-grey-w, #b6bac0);
    	border-width: 1px 0px 0px 0px;
    	padding: 10px 16px 10px 16px;
    	display: flex;
    	flex-direction: row;
    	gap: 10px;
    	align-items: flex-start;
    	justify-content: flex-start;
    	flex-shrink: 0;
    	position: relative;
	    width: 100%;
	}

	.table-header-item {
		justify-content: center;	
	}

	.item {
    	border-style: solid;
    	border-color: var(--color-silver, #f3f4f8);
    	border-width: 0px 0px 1px 0px;
    	padding: 10px 16px 10px 16px;
    	display: flex;
    	flex-direction: row;
    	gap: 10px;
	    align-items: center;
    	justify-content: flex-start;
    	flex-shrink: 0;
    	position: relative;
		min-height: 52px;
	}

	.body-item {
		display: flex;
		align-items: center;
		justify-content: center	;
	}

	input {
    	border-radius: 4px;
    	border-style: solid;
    	border-color: var(--color-grey-w, #b6bac0) !important;
    	border-width: 1px;
    	padding: 4px;
    	flex: 1;
    	width: 100%;
    	box-sizing: border-box;
    	color: var(--color-black, #101010);
    	text-align: left;
    	font-family: var(--b4-font-family);
	    font-size: var(--b4-font-size, 14px);
    	line-height: var(--b4-line-height, 22px);
    	letter-spacing: var(--b4-letter-spacing, -0.02em);
	    font-weight: var(--b4-font-weight, 400);
	    position: relative;
	    text-overflow: ellipsis;
	    overflow: hidden;
	    white-space: nowrap;
	    appearance: none;
	    -webkit-appearance: none;
	    -moz-appearance: none;
	}

	.list-section {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.error-overlay {
		position: fixed;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.45);
		z-index: 10;
	}

	.error-modal {
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
		min-width: 320px;
		max-width: 90%;
		display: flex;
		flex-direction: column;
	}

	.error-modal-header {
		padding: 14px 20px;
		background: #505050;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #fff;

		p {
			font-size: 16px;
			font-weight: 600;
		}

		button {
			background: none;
			border: none;
			cursor: pointer;
			padding: 0;
			display: flex;
			align-items: center;
			color: #fff;
			font-size: 20px;
			line-height: 1;
		}
	}

	.error-modal-body {
		padding: 28px 24px;
		font-size: 14px;
		color: #101010;
		text-align: center;
	}

	.error-modal-footer {
		padding: 0 24px 20px;
		display: flex;
		justify-content: center;
	}

	${({ $isMobile }) => $isMobile &&
    `
		.toggle-switch-wrap .toggle-switch {
			width: 36px;
			padding: 3px;
		}
		.toggle-switch-wrap .ellipse {
			width: 12px;
			height: 12px;
		}
		.table-wrapper {
			p {
				font-size: 14px;
			}
		}
		.table-item-wrap .item > .body-item:first-child {
			flex: 0 0 45px;
			min-width: 45px;
			max-width: 45px;
		}
		.table-header .table-header-item:first-child {
			min-width: 45px;
			max-width: 45px;
		}
	`}
`;
exports.TestSubTypeManager = react_1.default.memo(({ onClose }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [newTitle, setNewTitle] = (0, react_1.useState)('');
    const [editingId, setEditingId] = (0, react_1.useState)(null);
    const [editingTitle, setEditingTitle] = (0, react_1.useState)('');
    const [page, setPage] = (0, react_1.useState)(0);
    const [deleteErrorKey, setDeleteErrorKey] = (0, react_1.useState)(null);
    const { data, refetch } = (0, server_1.useSubTypes)({ offset: page * 5, limit: 5 });
    const items = data?.items ?? [];
    const totalCount = data?.total_count ?? 0;
    (0, react_1.useEffect)(() => {
        refetch();
    }, [page]);
    const createMutation = (0, react_query_1.useMutation)((title) => (0, server_1.createSubType)({ title, enabled: true }), {
        onSuccess: () => {
            setNewTitle('');
            refetch();
            onClose?.();
        },
    });
    const updateMutation = (0, react_query_1.useMutation)(({ id, payload }) => (0, server_1.updateSubType)(id, payload), {
        onSuccess: () => {
            setEditingId(null);
            refetch();
            onClose?.();
        },
    });
    const deleteMutation = (0, react_query_1.useMutation)((id) => (0, server_1.deleteSubType)(id), {
        onSuccess: () => {
            refetch();
            onClose?.();
        },
        onError: () => {
            setDeleteErrorKey('assignment.cannotDeleteLinkedSubType');
        },
    });
    const handleAdd = () => {
        const title = newTitle.trim();
        if (!title) {
            alert(t('assignment.inputSubTypeName'));
            return;
        }
        if (items.some(i => i.title === title)) {
            alert(t('assignment.duplicateSubTypeName'));
            return;
        }
        createMutation.mutate(title);
    };
    const handleEditSave = (id) => {
        const title = editingTitle.trim();
        if (!title) {
            alert(t('assignment.inputSubTypeName'));
            return;
        }
        updateMutation.mutate({ id, payload: { title } });
    };
    const handleDelete = (id) => {
        const item = items.find((i) => i.id === id);
        if (item?.enabled) {
            setDeleteErrorKey('assignment.cannotDeleteEnabledSubType');
            return;
        }
        deleteMutation.mutate(id);
    };
    const handleToggleEnabled = (id, currentEnabled) => {
        updateMutation.mutate({ id, payload: { enabled: !currentEnabled } });
    };
    // Embed editing state into item data so Table's memoized renderItem re-evaluates via tableList dep change
    const tableData = (0, react_1.useMemo)(() => items.map(item => ({
        ...item,
        _isEditing: item.id === editingId,
        _editingTitle: item.id === editingId ? editingTitle : item.title,
    })), [items, editingId, editingTitle]);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => {
            let content;
            if (headItem.title === 'title') {
                content = item._isEditing ? (react_1.default.createElement(common_1.InputElement, { type: "text", value: editingTitle, onChange: setEditingTitle })) : (react_1.default.createElement("p", { className: "overText", style: { ...styles?.bodyText, width: '100%', textAlign: 'left' } }, item.title));
            }
            else if (headItem.title === 'manage') {
                const iconSize = isMobile ? 14 : 18;
                content = item._isEditing ? (react_1.default.createElement("div", { className: "action-btns" },
                    react_1.default.createElement(common_1.Button, { option: { buttonBeforeIcon: { show: true, name: 'save', size: iconSize, color: Colors_1.Colors.tur } }, onClick: () => handleEditSave(item.id) }),
                    react_1.default.createElement(common_1.Button, { option: { buttonBeforeIcon: { show: true, name: 'close', size: isMobile ? 16 : 20, color: Colors_1.Colors.pink } }, onClick: () => setEditingId(null) }))) : (react_1.default.createElement("div", { className: "action-btns" },
                    react_1.default.createElement(common_1.Button, { option: { buttonBeforeIcon: { show: true, name: 'edit', size: iconSize, color: Colors_1.Colors.tur } }, onClick: () => { setEditingId(item.id); setEditingTitle(item.title); } }),
                    react_1.default.createElement(common_1.Button, { option: { buttonBeforeIcon: { show: true, name: 'delete', size: iconSize, color: Colors_1.Colors.pink } }, onClick: () => handleDelete(item.id) })));
            }
            else if (headItem.title === 'enabled') {
                content = (react_1.default.createElement(ToggleSwitch_1.ToggleSwitch, { isOn: item.enabled, setIsOn: () => handleToggleEnabled(item.id, item.enabled) }));
            }
            return (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: { flex: headItem.space, minWidth: headItem.minWidth, ...styles?.bodyItem } }, content));
        });
    };
    return (react_1.default.createElement(Styled, { "$isMobile": isMobile, style: { position: 'relative' } },
        react_1.default.createElement("div", { className: "add-section" },
            react_1.default.createElement("div", { className: "section-title" }, t('assignment.addSubType')),
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "fext-field" },
                    react_1.default.createElement(common_1.InputElement, { type: "text", value: newTitle, onChange: setNewTitle, placeholder: t('assignment.inputSubTypeName') }),
                    react_1.default.createElement(common_1.Button, { className: "btn_tur xmd", text: "common.add", onClick: handleAdd })))),
        react_1.default.createElement("div", { className: "divider" }),
        deleteErrorKey && (react_1.default.createElement("div", { className: "error-overlay" },
            react_1.default.createElement("div", { className: "error-modal" },
                react_1.default.createElement("div", { className: "error-modal-header" },
                    react_1.default.createElement("p", null, t('assignment.manageSubType')),
                    react_1.default.createElement("button", { onClick: () => setDeleteErrorKey(null) }, "\u2715")),
                react_1.default.createElement("div", { className: "error-modal-body" }, t(deleteErrorKey)),
                react_1.default.createElement("div", { className: "error-modal-footer" },
                    react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.okay", onClick: () => setDeleteErrorKey(null) }))))),
        react_1.default.createElement("div", { className: "list-section" },
            react_1.default.createElement("div", { className: "section-title" }, t('assignment.registeredSubTypeList')),
            react_1.default.createElement(common_1.Table, { className: "sub-type-table", isInfinite: false, showIndex: true, indexOrder: "desc", page: page, showCount: 5, pagingCount: 5, data: tableData, totalCount: totalCount, handlerMoreData: (p) => setPage(p), headTitleList: headTitleList, renderItem: renderItem, padding: false, renderEmpty: totalCount === 0 ? (react_1.default.createElement("div", { style: { textAlign: 'center', color: '#aaa', padding: '24px 0', fontSize: '14px' } }, t('common.noData'))) : undefined }))));
});
